import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import config from "../../config/config";
import CockpitShell from "../../components/CockpitShell";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Badge } from "../../components/ui/badge";

const navItems = [
  { href: "/dashboard/employer", label: "Overview", icon: "🏢" },
  { href: "/dashboard/stb/create", label: "Neue Anzeige", icon: "🆕" },
  { href: "/dashboard/stb/manage", label: "Verwalten", icon: "🧰" },
];

function authHeaders() {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

const StbPreview = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [ad, setAd] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    document.title = "Experts4Europe | Anzeigenvorschau";
    axios
      .get(`${config.API_BASE_URL}/api/stb/employer/ads/${id}`, { headers: authHeaders() })
      .then((res) => setAd(res.data || null))
      .catch((e) => setError(e.response?.data?.message || "Vorschau konnte nicht geladen werden."));
  }, [id]);

  return (
    <CockpitShell
      title="Anzeigenvorschau"
      subtitle="Preview wie spaetere oeffentliche Darstellung."
      badge="Preview"
      navItems={navItems}
      actions={
        <>
          <Button variant="outline" className="border-white/20 bg-transparent text-slate-100 hover:bg-white/10" onClick={() => navigate("/dashboard/stb/manage")}>
            Zurueck zur Verwaltung
          </Button>
          <Button className="bg-cyan-500 text-slate-950 hover:bg-cyan-300" onClick={() => navigate(`/dashboard/stb/create?id=${id}`)}>
            Bearbeiten
          </Button>
        </>
      }
    >
      {error ? <p className="rounded-lg border border-rose-300/30 bg-rose-500/10 p-3 text-sm text-rose-100">{error}</p> : null}
      {!ad && !error ? <p className="text-sm text-slate-300">Lade Vorschau...</p> : null}

      {ad ? (
        <Card className="card-e4e">
          <CardHeader>
            <div className="flex flex-wrap items-center gap-2">
              <Badge variant="outline" className="border-cyan-300/35 bg-cyan-500/10 text-cyan-100">{ad.status}</Badge>
              <Badge variant="outline" className="border-white/20 bg-white/5 text-slate-100">{ad.arbeitsform}</Badge>
              <Badge variant="outline" className="border-emerald-300/35 bg-emerald-500/10 text-emerald-100">Bonus {ad.onboarding_bonus}</Badge>
              <Badge variant="outline" className={Number(ad.wohnung) === 1 ? "border-emerald-300/35 bg-emerald-500/10 text-emerald-100" : "border-rose-300/35 bg-rose-500/10 text-rose-100"}>
                Wohnung {Number(ad.wohnung) === 1 ? "Ja" : "Nein"}
              </Badge>
            </div>
            <CardTitle className="font-display text-3xl text-white">{ad.titel}</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4 text-sm text-slate-200">
            <p><strong>Beruf:</strong> {ad.beruf_text}</p>
            <p><strong>Standort:</strong> {[ad.standort_land, ad.standort_ort].filter(Boolean).join(" / ") || "-"}</p>
            <p><strong>Gehalt:</strong> {ad.gehalt_text || [ad.gehalt_von, ad.gehalt_bis].filter(Boolean).join(" - ") || "-"}</p>
            <div className="rounded-xl border border-white/10 bg-slate-900/40 p-4">
              <h3 className="font-semibold text-white">Beschreibung</h3>
              <p className="mt-2 whitespace-pre-wrap">{ad.beschreibung || "-"}</p>
            </div>
            <div className="rounded-xl border border-white/10 bg-slate-900/40 p-4">
              <h3 className="font-semibold text-white">Aufgaben</h3>
              <p className="mt-2 whitespace-pre-wrap">{ad.aufgaben || "-"}</p>
            </div>
            <div className="rounded-xl border border-white/10 bg-slate-900/40 p-4">
              <h3 className="font-semibold text-white">Anforderungen</h3>
              <p className="mt-2 whitespace-pre-wrap">{ad.anforderungen || "-"}</p>
            </div>
          </CardContent>
        </Card>
      ) : null}
    </CockpitShell>
  );
};

export default StbPreview;

